import TotalDurationTime from "./TotalDurationTime";

export default TotalDurationTime;